<template>
  <div id="home">
    <Header />

    <div v-if="homeConfig.images !== undefied && homeConfig.images.length > 0">
      <SwiperPagination :images="homeConfig.images" />
    </div>

    <div class="white">.</div>

    <div class="filter-content">
      <PillsComponent
        :categories="categories"
        :filterMobile="false"
        @selectedCategory="selectedCategory"
      />
    </div>

    <div class="white">.</div>

    <TitleComponent text="Productos Destacados" />

    <ProductMasonry :products="getImportantProducts" />

    <div>
      <ButtonComponent
        text="Ver todos los productos"
        @onClick="onButtonClick()"
      />
    </div>

    <WppComponent />
    <Footer />
  </div>
</template>

<script>
import { db } from "../firebase";
import firebase from "firebase/firebase";
import SwiperPagination from "../components/SwiperPagination";
import PillsComponent from "../components/PillsComponent";
import ProductMasonry from "../components/ProductMasonry";
import TitleComponent from "../components/TitleComponent";
import WppComponent from "../components/WppComponent";
import ButtonComponent from "../components/ButtonComponent";
import Footer from "../components/Footer";
import Header from "../components/Header";
import mobile_detection from "../mixins/mobile_detection";
import user_detection from "../mixins/user_detection";

export default {
  mixins: [mobile_detection, user_detection],
  name: "Home",
  firebase: {
    products: db.ref("products"),
    categories: db.ref("categories"),
    homeConfig: db.ref("homeConfig"),
  },
  data() {
    return {
      products: [],
      categories: [],
      homeConfig: {},
    };
  },
  mounted() {
    this.isUserAdmin();
  },
  beforeDestroy() {},
  computed: {
    getImportantProducts() {
      var array = [];

      this.products.forEach((prod) => {
        if (prod.important != undefined && prod.important) {
          array.push(prod);
        }
      });

      return array;
    },
  },
  methods: {
    onButtonClick() {
      this.$router.replace("Products");
    },
    selectedCategory(category) {
      let url = "/products?c=" + category;
      this.$router.replace(url);
    },
    showProd(code) {
      this.$router.replace(`Product?c=${code}`);
    },
  },
  components: {
    SwiperPagination,
    PillsComponent,
    ProductMasonry,
    TitleComponent,
    WppComponent,
    ButtonComponent,
    Footer,
    Header,
  },
};
</script>

<style scoped>
.filter-content {
  background: rgba(95, 106, 121, 0.06);
  align-self: center;
}
.white {
  background: white;
  color: white;
}
.wrap {
  justify-content: center;
}
.row {
  margin-left: 0;
  margin-right: 0;
}
.item {
  height: max-content;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue